<template>
  <div id="chatroom">
    <section  class="container">

      <div class="modal-header top_header" v-if='view == "ChatList"'>
        <div class="f-gray_2 text_style title">
              線上劃位
        </div>
      </div>

      <div class="modal-header top_header" v-else-if='view !== "ChatList"'>
        <!-- 回上一頁 -->
        <div class="f-gray_2 text_style left_arrow" @click="goback"></div>

        <!-- 聊天室look -->
        <div class="f-gray_2 text_style title"  v-if='view == "ChatroomView"' >
              {{user_info.user_name}}
              <p v-if="user_info.last_contact_time">最後訊息:{{user_info.last_contact_time | handle_time}}</p>
        </div>

        <!-- 劃位資訊look -->
        <div class="f-gray_2 text_style title" v-else>
              劃位資訊
        </div>

      </div>
      

      <component ref="vwchat" :is="view"></component>
    
    </section>



  </div>
</template>

<script>
  import '@/assets/js/juqery_global.js';
  import '@/assets/js/ifvisible.js';
  import '@/assets/js/jquery_ui.js';
  import '@/assets/js/Mobile_Select.js';
  
  import BootstrapVue from 'bootstrap';

  import ChatList from "../Chatroom/ChatList";
  import ChatroomView from "../Chatroom/ChatroomView";
  import Appointment from "../Chatroom/Appointment";


  export default {
    name: 'Chatroom',
    components:{
      ChatList,
      ChatroomView,
      Appointment
    },
    props: {
      // 'store_id':Number
    },
    data: function () {
      return {
        view:'ChatList',
        user_info:{}
      }
    },
    methods: {
      // showAddRule() {}
      goback(){
        //切換視窗
        switch(this.view){
          //聊天室 -> 聊天列表
          case'ChatroomView':
              this.view = 'ChatList';
            break;
          //畫位資訊 -> 聊天室
          case'Appointment':
              this.view = 'ChatroomView';
            break;
        }
      }
    },
    computed: {
      
    },
    created() {
      this.$on('chang_view',function(obj){
            console.log('change_view',obj)

            this.view=obj.view;
            if (this.view === 'ChatroomView') {
              //進聊天室前要把店家手機版時的下面選單藏起來,讓點打字區時不會誤點到回首頁/功能切換的快速鍵減少聊天環境的干擾因素
              //不能在ChatroomView的init時才做,這樣下面會有空白
              this.$bus.hideMobileNavi = true
            }
            else {
              this.$bus.hideMobileNavi = false
            }
            if(obj.hasOwnProperty('user_info')){
              this.user_info=obj.user_info;
            }
        });
    },
    mounted () {
      // this.$refs.filterForm.initDefault()
      // setTimeout(() => {
      //   this.searchRestRules()
      //   this.$refs.addForm2.initDefault()
        
      // }, 100);
    },
    filters:{
        handle_AM_PM : function(value) {
            var hh = value.substring(0,2);
            if(hh > 12){
                hh = value.replace(hh,hh - 12);
                return '下午' + (hh > 9 ? hh:' '+hh);
            }else{
                return '上午' + ((parseInt(hh.substring(0,1)) < 1)? value.replace(hh,hh.substring(1,2)) : value);
            }
        },
        handle_time : function(value) {
            // value = "2019-12-11 17:04:24";

            var amount = new Date().getTime()-new Date(value.substr(0,10)).getTime(),days;
            amount = Math.floor(amount / 1000),//去掉milliseconds
                days = Math.floor(amount / 86400);//

            //‘-' 換成 '/'
            value = value.replace(/-/g,'/');

            //今天
            // -> 05:11
            if(days == 0){
                value = value.substring(11,16)
            }
            //非今天但在一年內
            // -> 06/11
            else if(days >= 1 & days < 366){
                value = value.substring(5,10)
            }
            //一年前
            // -> 2019/06/11
            else{
                value = value.substring(0,11)
            }

            return value;
        }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
   @import 'src/assets/css/chatroom_common.scss';
   
    #chatroom{
      overflow: hidden;
      // height: calc( 100vh / 1.3);
      padding: 0px;
      .container{
        padding: 0px;
        .modal-header{
          padding: 10px 0 10px 0;
          display: flex;
          align-items: center;
          .title p{
            font-size: 14px;
            line-height: 1.5;
            color: #888888;
            margin-top: 0;
            letter-spacing: 2px;
          }
        }
      }
      .top_header{
        .left_arrow{
          position: absolute;
          top: unset;
          left: unset;
          margin-left: 10px;
        }
        p{
          margin: 0px;
        }
      }
      .modal-header .left_arrow{
          width: 9px;
          height: 9px;
          border-top: 0.6px solid #948989;
          border-left: 0.6px solid #948989;
          transform: rotate(-45deg);
      }
      .modal-header .title{
          font-size: 22px;
          font-weight: bold;
          letter-spacing: -1.1px;
          color: rgba(1, 1, 1, 0.8);
          margin: 0 auto;
      }

      .search_store.opacity0,
      .seat_info_container,.visibility{
          // opacity: 0;
      }
      .ticket_info .title_text{
          font-size: 1rem;
      }
      .card-content{
          display: flex;
      }
      .card-image img{
          /*min-height: 98px;*/
          min-width: 157px;
          /*max-height: 98px;*/
          max-width: 157px;
      }
      .cancel,.seat{
          font-size: 1rem;
          font-weight: bold;
          letter-spacing: -0.53px;
          // color: var(--main-color);
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: solid 1px #eeeeee;
          margin: 10px 0 0;
          padding-top: 10px;
          line-height: 1;
      }
    }
</style>
